import { render, staticRenderFns } from "./EditQuiz.vue?vue&type=template&id=9ba976a0"
import script from "./EditQuiz.vue?vue&type=script&lang=js"
export * from "./EditQuiz.vue?vue&type=script&lang=js"
import style0 from "./EditQuiz.vue?vue&type=style&index=0&id=9ba976a0&prod&lang=css"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "./EditQuiz.vue?vue&type=style&index=2&id=9ba976a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports